<template>
    <div>
        <SimpleMicroWizard v-model="showWizard" :steps="wizardConfig.steps" @complete="handleComplete"
            @dismiss="handleDismiss" />
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import SimpleMicroWizard from '~/components/microwizard/SimpleMicroWizard.vue'
import type { MicroWizardConfig } from '~/src/types'
import { useLogger } from '~/composables/useLogger'
import { useI18n } from 'vue-i18n'

const router = useRouter()
const logger = useLogger()
const showWizard = ref(false)
const { t } = useI18n()

const wizardConfig: MicroWizardConfig = {
    id: 'clock-setup',
    steps: [
        {
            id: 'welcome',
            title: t('microwizards.clock.setup.welcome.title'),
            type: 'text',
            icon: {
                type: 'emoji',
                emoji: '🕒'
            },
            content: {
                text: t('microwizards.clock.setup.welcome.content')
            },
            actions: {
                primary: {
                    label: t('common.understood'),
                    action: 'NEXT'
                }
            }
        },
        {
            id: 'features',
            title: t('microwizards.clock.setup.features.title'),
            type: 'text',
            icon: {
                type: 'emoji',
                emoji: '📅'
            },
            content: {
                text: t('microwizards.clock.setup.features.content')
            },
            actions: {
                primary: {
                    label: t('microwizards.clock.setup.features.primary_action'),
                    action: () => {
                        logger.debug('ClockSetupMicroWizard: Navigating to onboarding')
                        router.push('/onboard-wiz')
                    }
                },
                secondary: {
                    label: t('microwizards.clock.setup.features.secondary_action'),
                    action: 'DISMISS'
                }
            }
        }
    ]
}

const handleComplete = () => {
    logger.debug('ClockSetupMicroWizard: Wizard completed')
    showWizard.value = false
}

const handleDismiss = () => {
    logger.debug('ClockSetupMicroWizard: Wizard dismissed')
    showWizard.value = false
}

// Expose methods to parent component
defineExpose({
    showWizard
})
</script>